import { render } from "./SupportArticle.vue?vue&type=template&id=481ddb52&scoped=true"
import script from "./SupportArticle.vue?vue&type=script&lang=js"
export * from "./SupportArticle.vue?vue&type=script&lang=js"

import "./SupportArticle.vue?vue&type=style&index=0&id=481ddb52&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481ddb52"]])

export default __exports__